export const QUERY_KEYS = {
  activeSpaceById: (activeSpaceId: string) => ['active-space', activeSpaceId],
  activityLogs: (spaceId: string, limit: number) => [
    'activity-logs',
    spaceId,
    limit
  ],
  analysesByCareer: (careerId: string) => ['career-analyses', careerId],
  answersBySpace: (spaceId: string) => ['answers', 'space', spaceId],
  answersWithAivyOutputCompare: (owner: string) => [
    'answers-with-aivy-output-compare',
    owner
  ],
  answersWithAivyOutputOrigin: (owner: string) => [
    'answers-with-aivy-output-origin',
    owner
  ],
  apiKeysByPartner: (partnerId: string) => ['api-keys-by-partner', partnerId],
  careerById: (careerId: string) => ['career', careerId],
  careerPreset: (careerPresetId: string) => ['career-preset', careerPresetId],
  // Zählquery für das Stellen-Limit (features/pricing/usage-queries.js). Eigener
  // Präfix, weil die queryFn unter 'careers' Tour-Stellen löscht. Ein
  // invalidate auf 'careers' trifft diesen Key deshalb nicht, dafür gibt es
  // invalidatePricingUsage.
  careerUsageByPartner: (partnerId: string) => ['career-usage', partnerId],
  careers: ['careers'],
  careersByPartner: (partnerId: string) => ['careers', partnerId],
  careersWithAnalysesByPartner: (partnerId: string) => [
    'careers-with-analyses',
    partnerId
  ],
  createCareerById: (id: string) => ['create-career', id],
  createTeamAnalyseById: (id: string) => ['create-team-analyse', id],
  employeesByUsername: (username: string) => ['employees', username],
  integrations: ['integrations'],
  leadQualificationFunnelById: (id: string) => [
    'lead-qualification-funnel',
    id
  ],
  logs: ['logs'],
  matchBatchIfYouCan: (
    careers: unknown,
    users: unknown,
    with_pre_matching: unknown
  ) => ['matchBatchIfYouCan', careers, users, with_pre_matching],
  matchMeIfYouCan: (talentId: string, partnerId: string) => [
    'matchMeIfYouCan',
    talentId,
    partnerId
  ],
  matchMeIfYouCanByOwnerAndPartner: (ownerId: string, partnerId: string) => [
    'match-me-if-you-can',
    ownerId,
    partnerId
  ],
  matchingByCareerAndUser: (careerId: string, userId: string) => [
    'matching',
    careerId,
    userId
  ],
  matchingProfile: (
    spaceId: string,
    userId: string,
    careerId: string,
    language: string,
    matching: unknown
  ) => ['matchingProfile', spaceId, userId, careerId, language, matching],
  partners: ['partners'],
  partnerById: (partnerId: string) => ['partner', partnerId],
  partnerIntegrationsByPartner: (partnerId: string) => [
    'partner-integrations',
    partnerId
  ],
  paymentByPartner: (partnerId: string) => ['payment', partnerId],
  personById: (personId: string) => ['person', personId],
  recoverTalentsByPartner: (partnerId: string) => [
    'recover/talents',
    partnerId
  ],
  // Ohne scope der globale Key, er ist zugleich Präfix für alle Scopes
  // (Invalidierung nach Entfernen oder Hinzufügen).
  sampleDataSummary: (partnerId: string, scope?: unknown) =>
    scope === undefined
      ? ['sample-data-summary', partnerId]
      : ['sample-data-summary', partnerId, scope],
  requirementProfile: (careerId: string, language: string) => [
    'requirementProfile',
    careerId,
    language
  ],
  spaceById: (spaceId: string) => ['space', spaceId],
  spaceFiles: (spaceId: string) => ['space-files', spaceId],
  spacesAccess: (username: string) => ['spaces-access', username],
  spacesByPartner: (partnerId: string) => ['spacesByPartner', partnerId],
  suggestedCareersByCompany: (companyName: string) => [
    'suggested-careers',
    companyName
  ],
  system: ['system'],
  featureFlags: ['feature-flags'],
  talentsByPartner: (partnerId: string, username: string) => [
    'talents',
    partnerId,
    username
  ],
  talentProfile: (spaceId: string, ownerId: string, language: string) => [
    'talentProfile',
    spaceId,
    ownerId,
    language
  ],
  teamAnalysesByPartner: (partnerId: string) => ['team-analyses', partnerId],
  teamAnalyse: (id: string, username: string) => ['team-analyse', id, username],
  teamProfile: (spaceIds: string[], language: string, careerId?: string) => [
    'teamProfile',
    spaceIds,
    language,
    careerId ?? null
  ],
  trialDataByPartner: (partnerId: string) => ['trial-data', partnerId],
  updateCareer: (careerId: string) => ['career', careerId],
  updatePartner: (partnerId: string) => ['partner', partnerId],
  userByUsername: (username: string) => ['user', username],
  userEndpointsByUsername: (username: string) => ['user-endpoints', username],
  userManagementByPartner: (partnerId: string) => ['user-management', partnerId]
}
